import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  AutoOrderSettingDetailApi,
  CreateMultiAutoOrderSettingDetailBody,
  DeleteMultiAutoOrderSettingDetailBody,
  FindToOrderChainSuppliersOptions,
  UpdateAutoOrderSettingDetailBody,
  UpdateMultiAutoOrderSettingDetailBody,
} from 'api';

export const findAutoOrderSettingDetailToOrderChainSuppliers = createAsyncThunk(
  'autoOrderSettingDetail/findAutoOrderSettingDetailToOrderChainSuppliers',
  async (option: FindToOrderChainSuppliersOptions, { rejectWithValue }) => {
    try {
      const response =
        await AutoOrderSettingDetailApi.findToOrderChainSuppliers(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findTotalChainOrderForOrder = createAsyncThunk(
  'autoOrderSettingDetail/findTotalChainOrderForOrder',
  async (_, { rejectWithValue }) => {
    try {
      const response =
        await AutoOrderSettingDetailApi.findTotalChainOrderForOrder();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const refreshAutoOrderSettingDetailProposalItems = createAsyncThunk(
  'autoOrderSettingDetail/refreshAutoOrderSettingDetailProposalItems',
  async (body: { pathID: string }, { rejectWithValue }) => {
    try {
      const response = await AutoOrderSettingDetailApi.refreshProposalItems(
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiAutoOrderSettingDetail = createAsyncThunk(
  'autoOrderSettingDetail/createMultiAutoOrderSettingDetail',
  async (body: CreateMultiAutoOrderSettingDetailBody, { rejectWithValue }) => {
    try {
      const response = await AutoOrderSettingDetailApi.createMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiAutoOrderSettingDetail = createAsyncThunk(
  'autoOrderSettingDetail/updateMultiAutoOrderSettingDetail',
  async (body: UpdateMultiAutoOrderSettingDetailBody, { rejectWithValue }) => {
    try {
      const response = await AutoOrderSettingDetailApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAutoOrderSettingDetail = createAsyncThunk(
  'autoOrderSettingDetail/updateAutoOrderSettingDetail',
  async (
    params: { id: string; body: UpdateAutoOrderSettingDetailBody },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await AutoOrderSettingDetailApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAutoOrderSettingDetail = createAsyncThunk(
  'autoOrderSettingDetail/deleteAutoOrderSettingDetail',
  async (params: { id: string; option: any }, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await AutoOrderSettingDetailApi.delete(id, option);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteMultiAutoOrderSettingDetail = createAsyncThunk(
  'autoOrderSettingDetail/deleteMultiAutoOrderSettingDetail',
  async (body: DeleteMultiAutoOrderSettingDetailBody, { rejectWithValue }) => {
    try {
      const response = await AutoOrderSettingDetailApi.deleteMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomerQuantityEqualProposedQuantity = createAsyncThunk(
  'autoOrderSettingDetail/updateCustomerQuantityEqualProposedQuantity',
  async (id: string, { rejectWithValue }) => {
    try {
      const response =
        await AutoOrderSettingDetailApi.updateCustomerQuantityEqualProposedQuantityV2(
          id
        );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomerQuantityEqualProposedQuantityOlder =
  createAsyncThunk(
    'autoOrderSettingDetail/updateCustomerQuantityEqualProposedQuantityOlder',
    async (id: string, { rejectWithValue }) => {
      try {
        const response =
          await AutoOrderSettingDetailApi.updateCustomerQuantityEqualProposedQuantity(
            id
          );
        return response;
      } catch (error: any) {
        if (!error.response) {
          throw error;
        }

        return rejectWithValue(error.response.data);
      }
    }
  );

interface State {
  totalAutoOrderSettingDetailOrder: number;
}

const initialState: State = {
  totalAutoOrderSettingDetailOrder: 0,
};

const autoOrderSettingDetailSlice = createSlice({
  name: 'autoOrderSettingDetail',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      findAutoOrderSettingDetailToOrderChainSuppliers.fulfilled,
      (state, action) => {
        const result: any = action.payload;

        state.totalAutoOrderSettingDetailOrder =
          result.totalAutoOrderSettingDetailOrder;
      }
    );
    builder.addCase(findTotalChainOrderForOrder.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.totalAutoOrderSettingDetailOrder =
        data.totalAutoOrderSettingDetailOrder;
    });
  },
});

const { reducer: autoOrderSettingDetailReducer } = autoOrderSettingDetailSlice;

export default autoOrderSettingDetailReducer;
